export default __webpack_public_path__ + "locales/de/EmptyTrashDialog.json?hash=f369be04c30d29e153c3f6038fcc8c35";